<template>
  <v-dialog max-width="600" v-model="dialog">
    <template v-slot:activator="{on, attrs}">
      <v-btn v-on="on" v-bind="attrs" :fab="operation === 'create'" :icon="operation === 'update'" color="primary"
             :aria-label="operation === 'update' ? 'Modifier le document' : 'Ajouter un document'">
        <v-icon>{{ operation === 'update' ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">{{ operation === 'update' ? 'Modifier le document' : 'Ajouter une pièce jointe' }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form ref="entrepriseAttachmentForm">
          <v-file-input :rules="operation === 'create' ? [notNullNorEmpty] : []" :label="operation === 'update' ? 'Remplacer le fichier (facultatif)' : 'Fichier'" v-model="entrepriseAttachment.file" chips></v-file-input>
          <v-select :rules="[notNullNorEmpty]" item-value="value" item-text="value" :items="entreprise_attachments_types" label="Type de document" v-model="entrepriseAttachment.type"></v-select>
          <date-field label="Date maximum de validité" v-model="entrepriseAttachment.date_validite"></date-field>
          <v-text-field label="Numéro de document (facultatif)" v-model="entrepriseAttachment.numero_document" maxlength="255"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="uplaoding" color="primary" @click="addDocument">{{ operation === 'update' ? 'Enregistrer' : 'Ajouter le document' }}</v-btn>
        <v-progress-circular v-if="uplaoding" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DateField from "@/components/base/DateField";
import {ValidationRulesMixin} from "@/mixins/ValidationRulesMixin";
import {EntrepriseAttachmentRepository} from "@/repository/entreprises";

export default {
  name: 'EntrepriseAttachmentDialog',
  components: {DateField},
  mixins: [ValidationRulesMixin],
  props: {
    operation: {type: String, default: "create"},
    attachment: {type: Object, default: () => ({})},
    entreprise: {
      type: Object,
      default: () => {},
    }
  },
  async mounted() {
    let selectFetchStatus = this.$store.getters["select/fetch_status"];
    if (selectFetchStatus === "INITIAL" || selectFetchStatus === "ERROR") {
      await this.$store.dispatch("select/fetchSelects");
    }
  },
  data() {
    return {
      repository: new EntrepriseAttachmentRepository(),
      dialog: false,
      entrepriseAttachment: {
        id: this.attachment.id,
        file: null,
        type: this.attachment.type || "",
        numero_document: this.attachment.numero_document || "",
        date_validite: this.attachment.date_validite || null,
        entreprise: this.entreprise.id,
      },
      uplaoding: false,
    }
  },
  methods: {
    async addDocument() {
      if (!this.$refs.entrepriseAttachmentForm.validate()) return;
      this.uplaoding = true;
      try {
        await this.repository.postFile({...this.entrepriseAttachment, date_validite: this.entrepriseAttachment.date_validite || ""}, this.operation === "update");
        this.dialog = false;
        this.$emit("reload");
        if (this.operation === "create") {
          this.entrepriseAttachment = {file: null, type: "", numero_document: "", date_validite: null, entreprise: this.entreprise.id};
          this.$refs.entrepriseAttachmentForm.resetValidation();
        }
        await this.$store.dispatch("annonce/annonceSuccess", this.operation === "update" ? "Document mis à jour" : "Document ajouté");
      } catch (error) {
        // The repository displays the upload error; keep the form available for retry.
      } finally {
        this.uplaoding = false;
      }
    }
  },
  computed: {
    entreprise_attachments_types() {
      return this.$store.getters["select/entreprise_attachments_types"];
    },
    selected_dossier() {
      return this.$store.getters["dossier/getSelectedDossier"];
    },
    fetch_status() {
      return this.$store.getters["dossier/getSingleItemFetchStatus"];
    },
  }
}
</script>
